// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__9ejGw","label":"LabeledBox_label__3wyLb"};